<template>

  <div > <!-- v-show="withError"  -->
    <ejs-sidebar

      zIndex="1000"

      :target="target"

      ref="sidebarInstance"

      :enablePersistence="true"

      :enableGestures="false"

    >

      <div class="main-menu" >

        <ul>

          <li class="nav-item" v-if="showOption('Home')">

            <router-link to="/">

              <font-awesome-icon :icon="['fas', 'home']" />

              <span class="side-nav-label">HOME</span>

            </router-link>

          </li>

          <li

            class="nav-item"

            v-if="(showOption('Login') || showOption('Register') || showOption('ForgottenPassword'))"

          >

            <font-awesome-icon :icon="['fas', 'info-circle']" />

            <span class="side-nav-label">MY ACCOUNT</span>

            <ul>

              <li v-if="showOption('Login')">

                <router-link to="/login">

                  <font-awesome-icon :icon="['fas', 'sign-in-alt']" />

                  <span class="side-nav-label">Sign In</span>

                </router-link>

              </li>

              <li v-if="showOption('Register')">

                <router-link to="/register">

                  <font-awesome-icon :icon="['fas', 'user-plus']" />

                  <span class="side-nav-label">Create Account</span>

                </router-link>

              </li>

              <li v-if="showOption('ForgottenPassword')">

                <router-link to="/password">

                  <font-awesome-icon :icon="['fas', 'unlock']" />

                  <span class="side-nav-label">Reset Password</span>

                </router-link>

              </li>

            </ul>

          </li>

          <li

            class="nav-item"

            v-if="

              showOption('SCCUserProfile') ||

              showOption('ManageCustomer') ||

              showOption('UpdatePassword') ||

              showOption('Transactions') ||

              showOption('Records') ||

              showOption('Sites')

            "

          >

            <font-awesome-icon :icon="['fas', 'info-circle']" />

            <span class="side-nav-label">ACCOUNT INFORMATION</span>

            <ul>

              <li v-if="showOption('SCCUserProfile') && isSccUser">

                <router-link :to="sccUserProfilePath">

                  <font-awesome-icon :icon="['fas', 'user-alt']" />

                  <span class="side-nav-label">My Contact Information</span>

                </router-link>

              </li>

              <li v-if="showOption('ManageCustomer') && !isSccUser">

                <router-link :to="userProfilePath">

                  <font-awesome-icon :icon="['fas', 'user-alt']" />

                  <span class="side-nav-label">My Contact Information</span>

                </router-link>

              </li>

              <li v-if="showOption('UpdatePassword')">

                <router-link to="/update-password">

                  <font-awesome-icon :icon="['fas', 'unlock']" />

                  <span class="side-nav-label">Change Password</span>

                </router-link>

              </li>

              <li v-if="showOption('Transactions')">

                <router-link to="/reports/transactions">

                  <font-awesome-icon :icon="['fas', 'dollar-sign']" />

                  <span class="side-nav-label">My Financial Transactions</span>

                </router-link>

              </li>

              <li v-if="showOption('Records')">

                <router-link to="/records">

                  <font-awesome-icon :icon="['fas', 'file-alt']" />

                  <span class="side-nav-label">My Permits & Records</span>

                </router-link>

              </li>

              <li v-if="showOption('Sites') && (isOwner || isSuperAdmin || isAdmin)">

                <router-link to="/sites" data-test-navbar="msi">

                  <font-awesome-icon :icon="['fas', 'sitemap']" />

                  <span class="side-nav-label">My Site Information</span>

                </router-link>

              </li>

            </ul>

          </li>

          <li class="nav-item">

            <img width="20px" height="auto" src="../assets/bp-icon-sts.png" alt="" />

            <span class="side-nav-label">STORAGE TANK MANAGEMENT</span>

            <ul>

              <li v-if="showOption('STSWP')">

                <router-link

                  :to="{

                    name: 'STSWP',

                    query: { permitType: 'STSWP' },

                  }"

                  data-test-navbar="stswp"

                >

                  <font-awesome-icon :icon="['fas', 'plus-square']" />

                  <span class="side-nav-label">Storage Tank System Work Permit</span>

                </router-link>

              </li>

              <li  class="nav-item" v-if="showOption('STSRWP')">

                <router-link

                  :to="{

                    name: 'STSRWP',

                    query: { permitType: 'STSRWP' },

                  }"

                >

                  <div class="icons-wrapper">

                    <font-awesome-icon :icon="['fas', 'plus']" style="display: block" />

                    <font-awesome-icon :icon="['fas', 'minus']" />

                  </div>

                  <span>Storage Tank System Removal and Work Permit</span>

                </router-link>

              </li>

              <li v-if="showOption('STSRP')">

                <router-link

                  :to="{

                    name: 'STSRP',

                    query: { permitType: 'STSRP' },

                  }"

                >

                  <font-awesome-icon :icon="['fas', 'minus-circle']" />

                  <span class="side-nav-label">Storage Tank System Removal Permit</span>

                </router-link>

              </li>

            </ul>

          </li>

          <!-- PERMIT SEARCH menu hidden

          <li class="nav-item">

            <font-awesome-icon :icon="['fas', 'search']" />

            <span class="side-nav-label">PERMIT SEARCH</span>

            <ul>

              <li v-if="showOption('SelectMuniForSR')">

                <router-link to="/search/muniforsr" data-test-navbar="stsr">

                  <font-awesome-icon :icon="['fas', 'map-marker-alt']" />

                  <span class="side-nav-label">Storage Tank Search Request <br><span style="font-size:12px"> <b>FOR 3RD PARTY LEGAL AND ENVIRONMENTAL USE</b></span> </span>

                </router-link>

              </li>

            </ul>

          </li>

          -->

          <li

            class="nav-item"

            v-if="

              showOption('SCCUserList') ||

              showOption('ManageProductPrices') ||

              showOption('openInvoices') || // ToDo: change route names to be meaningful

              showOption('Users') ||

              showOption('WebUserList') ||

              showOption('ManagePagesRoles') ||

              showOption('MunicipalityMessages') ||

              showOption('EmailStageTemplateList') ||

              showOption('JobEventList')

            "

          >

            <font-awesome-icon :icon="['fas', 'user-secret']" />

            <span class="side-nav-label">ADMIN</span>

            <ul>

              <li v-if="showOption('SCCUserList')">

                <router-link to="/scc-user-list">

                  <!-- /internal -->

                  <font-awesome-icon :icon="['fas', 'user-circle']" />

                  <span class="side-nav-label">Manage SCC User Accounts</span>

                </router-link>

              </li>

              <li v-if="showOption('ManageProductPrices')">

                <router-link to="/products/productprices">

                  <font-awesome-icon :icon="['fab', 'product-hunt']" />

                  <span class="side-nav-label">Manage Products</span>

                </router-link>

              </li>

              <li v-if="showOption('openInvoices')">

                <router-link to="/accounting/manage-accounting">

                  <font-awesome-icon :icon="['fas', 'dollar-sign']" />

                  <span class="side-nav-label">Manage Accounting</span>

                </router-link>

              </li>

              <li v-if="showOption('Users')">

                <router-link to="/users">

                  <font-awesome-icon :icon="['fas', 'address-card']" />

                  <span class="side-nav-label">Manage Customer Details</span>

                </router-link>

              </li>

              <li v-if="showOption('WebUserList')">

                <router-link to="/web-user-list">

                  <!-- /public -->

                  <font-awesome-icon :icon="['fas', 'users']" />

                  <span class="side-nav-label">Manage Web Login Users</span>

                </router-link>

              </li>

              <li v-if="showOption('ManagePagesRoles')">

                <router-link to="/manage-pages-roles">

                  <!-- /public -->

                  <font-awesome-icon :icon="['fas', 'users']" />

                  <span class="side-nav-label">Manage Pages Permissions</span>

                </router-link>

              </li>

              <li v-if="showOption('MunicipalityMessages')">

                <router-link to="/municipality-messages">

                  <!-- /public -->

                  <font-awesome-icon :icon="['fas', 'mail-bulk']" />

                  <span class="side-nav-label">Manage Municipality Messages</span>

                </router-link>

              </li>

              <li

                class="nav-item"

                v-if="showOption('EmailStageTemplateList') || showOption('JobEventList')"

              >

                <font-awesome-icon :icon="['fas', 'envelope']" />

                <span class="side-nav-label">Manage Notifications</span>

                <ul>

                  <li v-if="showOption('EmailStageTemplateList')">

                    <router-link to="/email-stage-list">

                      <font-awesome-icon :icon="['fas', 'at']" />

                      <span class="side-nav-label">Manage Email Templates</span>

                    </router-link>

                  </li>

                  <li v-if="showOption('JobEventList')">

                    <router-link to="/job-events-list">

                      <font-awesome-icon :icon="['fas', 'bell']" />

                      <span class="side-nav-label">Manage Notification Jobs</span>

                    </router-link>

                  </li>

                  <li class="nav-item" v-if="showOption('JobEventList')">

                    <router-link to="/manage-outage">

                      <font-awesome-icon :icon="['fas', 'tools']" />

                      <span class="side-nav-label">Manage System Outage</span>

                    </router-link>

                  </li>

                  <li>

                <router-link to="/announcements">

                     <font-awesome-icon :icon="['fas', 'bell']" /> <!--'fa-volume-up' -->

                  <span class="side-nav-label">Manage Announcements</span>

                </router-link>

              </li>

                </ul>

              </li>

              <li class="nav-item" v-if="showOption('FormsCategory')">

                <router-link to="/forms/category">

                  <font-awesome-icon :icon="['fas', 'file-alt']" />

                  <span class="side-nav-label">Manage Help Documents/Forms</span>

                </router-link>

              </li>

            </ul>

          </li>

          <li

            class="nav-item"

            v-if="showOption('AccountingReportsHome') || showOption('ASCAReportsHome')"

          >

            <font-awesome-icon :icon="['fas', 'file-alt']" />

            <span class="side-nav-label">REPORTS</span>

            <ul>

              <li v-if="showOption('AccountingReportsHome')">

                <router-link to="/reports/accounting-reports">

                  <font-awesome-icon :icon="['fas', 'donate']" />

                  <span class="side-nav-label">Accounting Reports</span>

                </router-link>

              </li>

              <li v-if="showOption('ASCAReportsHome')">

                <router-link to="/reports/asca-reports">

                  <font-awesome-icon :icon="['fas', 'chart-pie']" />

                  <span class="side-nav-label">ASCA Reports</span>

                </router-link>

              </li>

            </ul>

          </li>

          <li class="nav-item" >

            <router-link to="/forms">

              <font-awesome-icon :icon="['fas', 'file-alt']" />

              <span class="side-nav-label">HELP DOCUMENTS/FORM</span>

            </router-link>

          </li>

          <li class="nav-item" v-if="showOption('ContactUs')">

            <router-link to="/contact-us">

              <font-awesome-icon :icon="['fas', 'phone-alt']" />

              <span class="side-nav-label">CONTACT</span>

            </router-link>

          </li>

        </ul>

      </div>

    </ejs-sidebar>

  </div>

</template>

<script>

import VueScreenSize from "vue-screen-size";

import { mapGetters } from "vuex";

import { FETCH_SHOPPING_CART_BY_USER_ID } from "../modules/financials/store";

import RouteAccessHelper from "../router/route-access-helper";

export default {

  props: {

    toggleTriggered: {

      type: Boolean,

      default: false,

    },

    isAuthenticated: {

      type: Boolean,

      default: false,

    },

    isAdmin: {

      type: Boolean,

      default: false,

    },

    isSuperAdmin: {

      type: Boolean,

      default: false,

    },

    isOwner: {

      type: Boolean,

      default: false,

    },

    isAccounting: {

      type: Boolean,

      default: false,

    },

    loggedUserId: {

      type: String,

      default: "",

    },

    isSccUser: {

      type: Boolean,

      default: false,

    },

  },

  mixins: [VueScreenSize.VueScreenSizeMixin],

  data() {
    return {

      target: ".main-content",

      withError: false,

      isFloated: false,

    };
  },

  watch: {

    isAuthenticated(val) {
      if (val) {
        this.getShoppingCartByUserId();
      }
    },

    toggleTriggered(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.toggleClick();
      }
    },

    $vssWidth(newVal) {
      if (newVal < 1122) {
        this.isFloated = true;

        this.$refs.sidebarInstance.hide();
      } else {
        this.isFloated = false;

        this.$refs.sidebarInstance.show();
      }
    },

    $route(to, from) {
      if (this.isFloated) {
        this.$refs.sidebarInstance.hide();
      } else {
        this.$refs.sidebarInstance.show();
      }
    },

  },

  mounted() {
    this.$refs.sidebarInstance.show();
  },

  computed: {

    ...mapGetters({

      userPermissions: "userPermissions",

      guestPermissions: "guestPermissions",

    }),

    userProfilePath() {
      return `/manage-customer/${this.loggedUserId}`;
    },

    sccUserProfilePath() {
      return `/scc-user-profile/${this.loggedUserId}`;
    },

    updatePasswordPath() {
      return `/update-password/${this.loggedUserId}`;
    },

  },

  methods: {

    toggleClick() {
      if (this.$refs.sidebarInstance.ej2Instances.isOpen) {
        this.$refs.sidebarInstance.hide();
      } else {
        this.$refs.sidebarInstance.show();
      }
    },

    showOption(optionName) {
      return RouteAccessHelper.isAuthorized(optionName);
    },

    async getGuestPermission() {
      try {

        /** This is commented out when the page level authorization is implemented. Todo: Refactor */

        // await this.$store.dispatch(FETCH_GUEST_PERMISSION);

      } catch (err) {
        this.withError = true;
      }
    },

    async getUserPermission() {

      /** This is commented out when the page level authorization is implemented, Todo: Refactor */

      // await this.$store.dispatch(FETCH_USER_PERMISSION);

    },

    async getShoppingCartByUserId() {
      try {
        if (

          this.loggedUserId !== null

          && this.loggedUserId !== ""

          && this.loggedUserId !== "undefined"

        ) {
          const userId = this.loggedUserId;

          if (userId) {
            await this.$store.dispatch(FETCH_SHOPPING_CART_BY_USER_ID, userId);
          }
        }
      } catch (error) {
        this.notify("Error", error.message);
      }
    },

  },

};

</script>

<style>

.main-menu {

  font-size: 14px;

  width: 370px;

}

.main-menu ul {

  list-style-type: none;

  padding-inline-start: 8px;

  overflow: hidden;

}

.main-menu ul li {

  margin: 0 0 6px 8px;

}

.nav-item div, svg, img{

  min-width: 20px;

}

.main-menu a {

  color: #0f4b90;

  text-decoration: none;

}

.main-menu a:hover {

  font-weight: 500;

}

.main-menu a.router-link-exact-active {

  font-weight: 500;

}

.side-nav-label {

  margin-left: 8px;

}

.main-menu ul ul {

  margin: 10px 0 10px 8px;

}

.icons-wrapper {

  padding: 0 3px 0 3px;

  font-size: 6px;

  display: inline-block;

}

.e-sidebar.e-left {

  position: fixed;

  height: 83%;

  top: unset !important;

}

</style>
